import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay, Navigation } from "swiper/modules";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";

import slide1 from "@/assests/slide1.jpg";
import slide2 from "@/assests/slide2.jpg";
import slide3 from "@/assests/slide3.jpg";

const Banner = () => (
  <div className="h-full relative group">
    <Swiper
      navigation={{
        prevEl: "#prevSlide",
        nextEl: "#nextSlide",
      }}
      autoplay={{
        delay: 1500,
        disableOnInteraction: false,
      }}
      loop={true}
      modules={[Autoplay, Navigation]}
      className="aspect-[4/1] w-full h-full cursor-pointer "
    >
      <SwiperSlide>
        <img className="w-full h-full" src={slide1} alt="Slide 1" />
      </SwiperSlide>
      <SwiperSlide>
        <img className="w-full h-full" src={slide2} alt="Slide 2" />
      </SwiperSlide>
      <SwiperSlide>
        <img className="w-full h-full" src={slide3} alt="Slide 3" />
      </SwiperSlide>
      <button
        id="prevSlide"
        className="hidden md:block hover:bg-black/80	absolute left-0 lg:-left-12 transition-all group-hover:left-0 top-1/2 transform -translate-y-1/2 z-10  duration-200 bg-black/60 text-white pl-0 pr-3 py-6 rounded-r-full shadow-lg"
      >
        <FaAngleLeft className="w-6 h-6" />
      </button>

      <button
        id="nextSlide"
        className="hidden md:block hover:bg-black/80 absolute right-0 lg:-right-12 transition-all group-hover:right-0 top-1/2 transform -translate-y-1/2 z-10 duration-200 bg-black/60 text-white pl-3 pr-0 py-6 rounded-l-full shadow-lg"
      >
        <FaAngleRight className="w-6 h-6" />
      </button>
    </Swiper>
  </div>
);

export default Banner;
